import BrandArticle from "@/pages/article/components/BrandArticle";
import { brandArticles } from "@/mocks/brandArticles";

const data = brandArticles.find((a) => a.slug === "joyabuy-spreadsheet")!;

export default function JoyabuySpreadsheetPage() {
  return <BrandArticle data={data} />;
}